import useFirebase from "./useFirebase";

const useAuth = () => {
  return useFirebase();
};

export default useAuth;
